<template>
    <div class="a-form-inputs a-form-inputs--table">
        <form @submit.prevent>
            <accordion>
                <general-damages></general-damages>
                <past-cost-of-care></past-cost-of-care>
                <past-cost-of-travel></past-cost-of-travel>
                <past-loss-of-earnings></past-loss-of-earnings>
            </accordion>

            <step-button :next-valid="allValid"></step-button>
        </form>
    </div>
</template>

<script>
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import StepButton from 'components/StepButton.vue';
    import Benefit from  'components/CruBenefits/Benefit.vue';
    import {mapGetters, mapActions} from 'vuex';
    import Accordion from 'components/accordion/Accordion.vue';
    import AccordionItem from 'components/accordion/AccordionItem.vue';
    import FormValidator from 'components/form/validator/mixin';
    import GeneralDamages from './cru-benefits/GeneralDamages';
    import PastCostOfCare from './cru-benefits/PastCostOfCare';
    import PastCostOfTravel from './cru-benefits/PastCostOfTravel';
    import PastLossOfEarnings from './cru-benefits/PastLossOfEarnings';
    import {setStepValid} from 'services/routingMethods';

    export default {
        mounted() {
            setStepValid(this.allValid);
        },
        components: {
            Accordion,
            AccordionItem,
            Control,
            ControlError,
            Benefit,
            StepButton,
            GeneralDamages,
            PastCostOfCare,
            PastCostOfTravel,
            PastLossOfEarnings
        },
        mixins: [FormValidator],
        computed: {
            ...mapGetters('personal/headsOfLoss', ['value']),
            ...mapGetters('personal/cruBenefits', {
                findValue: 'value',
                findInclude: 'include',
                allValid: 'allValid'
            }),
        },
        methods: {
            ...mapActions('personal/headsOfLoss', {
                setValue: 'updateValue',
                updateInterest: 'calcNewValue',
                calcInterest: 'calcInterest'
            }),
        }
    }
</script>


// WEBPACK FOOTER //
// CruBenefits.vue?41dcdef5